var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { ofType, combineEpics } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { from, of } from "rxjs";
import { WORKSPACE_ID } from "@ane/core/lib/constants/QueryString.constants";
import graphService from "@ane/core/lib/services/GraphService";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import NavigationService from "@ane/core/lib/services/NavigationService";
import UsersResource from "../resources/UserResources.js";
import MdsDataplaneResource from "../resources/MdsDataplaneResource.js";
import { u as updatedCurrentUserMetadata, l as loadedUserAffinity, a as loadExperimentationGroup, b as loadingUserAffinity, c as loadedExperimentationGroup, d as loadingExperimentationGroup } from "../CurrentUserDetailsActions-e58069ba.js";
import CurrentUserDetailsActionConstants from "./CurrentUserDetailsActionsConstants.js";
import { isOnboardingPathname, getOnboardingPagePath } from "../routes/WorkspaceTenantSelectorRoute.utils.js";
import { WindowLocation } from "@ane/core/lib/services/WindowService";
import Logger from "@ane/core/lib/services/logging/Logger";
import { WorkspaceMigrationTelemetryEventNames } from "../telemetry/WorkspaceMigrationTelemetryEventNames.js";
import { hasEntityBeenMigrated } from "@ane/core/lib/utils/WorkspaceMigration.utils";
import { getDefaultWorkspaceId, getLastExperimentationGroupId, getLastWorkspaceId, setUserAffinity, setLastExperimentationGroup } from "./GetUserAffinity.utils.js";
import { UserDetailTelemetryEventNames } from "./UserDetailTelemetryEventNames.js";
import { getNewGuid } from "@ane/core/lib/utils/CommonStringUtils";
import { AppTelemetryEventNames } from "../telemetry/AppTelemetryEventNames.js";
import "../utils/ManagementGroup/index.js";
import { isClassicWorkspaceById } from "../utils/ManagementGroup/ManagementGroup.utils.js";
const getCurrentUserDetailsMetadata = (action$) => {
  return action$.pipe(
    ofType(CurrentUserDetailsActionConstants.UPDATE_CURRENT_USER_METADATA),
    mergeMap((value) => {
      const getCurrentUserDetailsMetadata2 = from(graphService.getUserInfo(value.payload.id)).pipe(
        mergeMap((adu) => {
          const imageCall = from(graphService.getUserImage(value.payload.id)).pipe(
            mergeMap((img) => {
              return of(
                updatedCurrentUserMetadata({
                  id: value.payload.id,
                  aadUserInfo: adu || null,
                  userImage: img.isSuccessful() ? img.getSuccessData() : ""
                })
              );
            })
          );
          return imageCall;
        })
      );
      return from([getCurrentUserDetailsMetadata2]).pipe(mergeMap((x) => x));
    })
  );
};
const getCurrentUserWorkspaceGroupAffinity = (action$, state$) => {
  return action$.pipe(
    ofType(CurrentUserDetailsActionConstants.LOAD_USER_AFFINITY),
    mergeMap(() => {
      const correlationId = getNewGuid();
      const alias = EnvironmentService.getUser().alias;
      const workspaceId = getDefaultWorkspaceId();
      const localExperimentationGroup = getLastExperimentationGroupId();
      Logger.trackMetric({
        name: UserDetailTelemetryEventNames.UserDetails_getCurrentUserWorkspaceGroupAffinity_defaults,
        average: 0,
        properties: {
          defaultWorkspaceId: getDefaultWorkspaceId(),
          queryWorkspaceId: EnvironmentService.getQueryParam(WORKSPACE_ID),
          localWorkspaceId: getLastWorkspaceId(),
          localExperimentationGroup,
          correlationId
        }
      });
      const getCurrentUserDetailsMg = from(
        /**
         * If workspaceId is empty pass undefined to return default
         */
        UsersResource.getUserManagementGroupV2(alias, !!(workspaceId == null ? void 0 : workspaceId.length) ? workspaceId : void 0, 0)
      ).pipe(
        mergeMap((userResult) => {
          var _a, _b, _c, _d;
          const lastWorkspaceId = getLastWorkspaceId();
          const user = userResult.getSuccessData();
          const userWorkspace = EnvironmentService.getWorkspaceIdOrDefault((user == null ? void 0 : user.WorkspaceId) || workspaceId);
          const rootWorkspacePath = !isClassicWorkspaceById(userWorkspace) ? ((_d = (_c = (_b = (_a = state$ == null ? void 0 : state$.value) == null ? void 0 : _a.workspace_data) == null ? void 0 : _b.workspace) == null ? void 0 : _c.data) == null ? void 0 : _d.Path) || "" : "";
          const userMg = (user == null ? void 0 : user.ManagementGroup) || rootWorkspacePath;
          Logger.trackMetric({
            name: UserDetailTelemetryEventNames.UserDetails_getCurrentUserWorkspaceGroupAffinity_userAffinity,
            average: 0,
            properties: {
              defaultWorkspaceId: getDefaultWorkspaceId(),
              localWorkspaceId: lastWorkspaceId,
              localExperimentationGroup,
              queryWorkspaceId: EnvironmentService.getQueryParam(WORKSPACE_ID),
              correlationId,
              userWorkspace,
              userMg
            }
          });
          let defaultExperimentationGroup = userMg;
          defaultExperimentationGroup = lastWorkspaceId === userWorkspace && !!localExperimentationGroup ? localExperimentationGroup : defaultExperimentationGroup || "";
          if (!lastWorkspaceId) {
            setUserAffinity(userWorkspace, userMg);
          }
          if (!!lastWorkspaceId && lastWorkspaceId === userWorkspace && !!defaultExperimentationGroup && !localExperimentationGroup) {
            setLastExperimentationGroup(defaultExperimentationGroup);
          }
          return of(
            loadedUserAffinity(userWorkspace, defaultExperimentationGroup),
            loadExperimentationGroup(userWorkspace, defaultExperimentationGroup)
          );
        })
      );
      const loading = of(loadingUserAffinity());
      return from([loading, getCurrentUserDetailsMg]).pipe(mergeMap((x) => x));
    })
  );
};
const getExperimentationGroup = (action$) => {
  return action$.pipe(
    ofType(CurrentUserDetailsActionConstants.LOAD_EXPERIMENTATION_GROUP),
    mergeMap((value) => {
      const { workspaceId, managementGroup } = value.payload;
      const loadExperimentationGroup2 = from(MdsDataplaneResource.getExperimentationGroupV2(workspaceId, managementGroup)).pipe(
        // @ts-ignore
        mergeMap((result) => {
          const data = result.getSuccessData();
          if (EnvironmentService.wsplitEnableRedirects() && hasEntityBeenMigrated(result) && !!(data == null ? void 0 : data.workspaceId)) {
            Logger.trackEvent({
              name: WorkspaceMigrationTelemetryEventNames.WSMigration_GetExperimentationGroup_moved,
              properties: __spreadProps(__spreadValues({
                error: result.error
              }, result.errorContext), {
                redirectWorkspaceId: data == null ? void 0 : data.workspaceId
              }),
              measurements: {}
            });
            return of(
              loadedExperimentationGroup(
                workspaceId,
                managementGroup,
                /**
                 * Workspace migration
                 * Must return null - we do not want to store the 301 response in redux, this is invalid
                 */
                null,
                /**
                 * Workspace migration
                 * Do not show error to user when default experimentation group has been migated
                 * Customers may be attempting to view an entity in another experimentation group
                 */
                ""
              )
            );
          }
          return of(loadedExperimentationGroup(workspaceId, managementGroup, data, ""));
        }),
        catchError((error) => {
          var _a;
          const group = !!managementGroup ? `/group ${managementGroup}` : "";
          let errorMsg = `Failed to fetch experiment workspace ${workspaceId}${group}.`;
          if (((_a = error == null ? void 0 : error.innerError) == null ? void 0 : _a.statusCode) === 404) {
            errorMsg = ` Experiment workspace ${workspaceId}${group} cannot be found. Please verify the workspace Id.`;
          }
          Logger.trackEvent({
            name: AppTelemetryEventNames.App_Init_GetExperimentationGroup_Failed,
            properties: __spreadProps(__spreadValues({}, error), {
              errorMsg
            }),
            measurements: {}
          });
          if (!isOnboardingPathname()) {
            Logger.trackEvent({
              name: AppTelemetryEventNames.App_Init_GetExperimentationGroup_RedirectToOnboarding,
              properties: __spreadValues({}, error),
              measurements: {}
            });
            const path = getOnboardingPagePath();
            NavigationService.openExternalLinkInCurrentTab(`${path}${WindowLocation.search}${WindowLocation.hash}`);
          }
          return of(loadedExperimentationGroup(workspaceId, managementGroup, null, errorMsg));
        })
      );
      const loading = of(loadingExperimentationGroup(workspaceId, managementGroup));
      return of(loading, loadExperimentationGroup2).pipe(mergeMap((x) => x));
    })
  );
};
const UserDetailsEpic = combineEpics(getCurrentUserDetailsMetadata, getCurrentUserWorkspaceGroupAffinity, getExperimentationGroup);
export {
  UserDetailsEpic as default,
  getCurrentUserDetailsMetadata,
  getCurrentUserWorkspaceGroupAffinity,
  getExperimentationGroup
};
//# sourceMappingURL=UserDetailsEpic.js.map
